import gql from 'graphql-tag';

const DAILY_BRIEF_METRICS_FRAGMENT = gql`
	fragment serviceRunDailyBriefMetrics on ServiceRun {
		id
		serviceDockets {
			id
			pickListGenerationStatus
			totalPickItemsQuantity
			expiryProductsCount
			machine {
				id
				type
				nextServicePriceChangesCount
				planogram {
					id
				}
				ingredientPlanogramId
				planogramItemNextExpiryDate
				isOffline
			}
		}
	}
`;

export default DAILY_BRIEF_METRICS_FRAGMENT;
